import backButtonService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/backButtonService';

function handleBootstrapModals() {
    const modals = document.querySelectorAll('.modal.show');
    modals.forEach((modal) => {
        modal.isHiddenByClickingBackButton = true;
        $(modal).modal('hide');
    });
}

function setupModalListeners() {
    $(document).on('shown.bs.modal', () => {
        backButtonService.addBackButtonListener(() => handleBootstrapModals());
    });

    $(document).on('hidden.bs.modal', (event) => {
        const modal = event.target;
        if (!modal.isHiddenByClickingBackButton) {
            backButtonService.popStateWithoutTriggeringEvent();
        }
        modal.isHiddenByClickingBackButton = false;
        setTimeout(() => {
            backButtonService.removeBackButtonListener();
        }, 0);
    });
}

window.addEventListener('DOMContentLoaded', () => {
    if (window.jQuery && typeof $.fn.modal === 'function') {
        setupModalListeners();
    }
});
